import { Component, OnInit } from '@angular/core';
import { AvailableComponents } from '../../../side-bar/enumAvailableComponents';
import { DataStorageService } from '../../../data-storage.service';
import { PricingService } from '../../../pricing.service';
import { ApiService } from '../../../api.service';
import { SBCplusPrincing } from '../../../../models/SBCplusPricing';
import { SBCplus } from '../../../../models/SBCplus';

@Component({
  selector: 'app-sbcplus',
  templateUrl: './sbcplus.component.html',
  styleUrls: ['./sbcplus.component.scss']
})
export class SbcplusComponent implements OnInit {
  private priceLists:Array<SBCplusPrincing>;
  private options:Array<number>;
  constructor(public dataStorageService: DataStorageService,
    public api: ApiService,
    private pricing: PricingService) {
      pricing.getSBCplusPriceList().then(data => {
        this.priceLists = data;
        this.options = this.priceLists.map(price => price.channels)
      })
    }

  ngOnInit() {
    const element = document.getElementById('msTeams-SBCplus');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['SBCplus'];
  }

  ngOnDestroy() {
    const element = document.getElementById('msTeams-SBCplus');
    element.classList.remove('active');
  }

  getCostMonthly()
  {
    return this.dataStorageService.currentState.sbcplus.costMonthly;
  }

  getCostUnique()
  {
    return this.dataStorageService.currentState.sbcplus.costUnique
  }

  updateSBCplus(event)
  {
    var sbc = SBCplus.fromPriceList(this.priceLists[this.options.indexOf(parseInt(event.target.value))]);
    sbc.id = this.dataStorageService.currentState.sbcplus.id

    this.api.putSBCplus(this.dataStorageService.currentState.offerID, sbc)
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/sbcplus/sbcplus.component.ts